<template>
	<div class="dashboard">
		<navComponent/>
		<div class="container-fluid" style="width: 95%;">
			<div class="row">
				<div class="col-12 col-md-3 rounded">
					<div class="card">
						<sideBar></sideBar>
					</div>
				</div>
				<div class="col-12 col-md-9">
					<div class="card">
						<nav>
							<div class="nav nav-tabs" style="text-align: center;" id="nav-tab">
								<a
									class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab"
									aria-controls="nav-home" aria-selected="true" @click="showHome">
									<div class="row">
										<div class="col-2">
											<i class="fa fa-home"></i>
										</div>
										<div class="col-9">
											<p class="mb-0"><b>HOME</b></p>
										</div>
									</div>
								</a>
								<a
									href="#nav-event" class="nav-item nav-link" id="nav-event-tab" data-toggle="tab" role="tab"
									aria-controls="nav-event" aria-selected="false" @click="showEvent">
									<div class="row">
										<div class="col-2">
											<i class="fa fa-calendar"></i>
										</div>
										<div class="col-9">
											<p class="mb-0"><b>EVENTS</b></p>
										</div>
									</div>
								</a>
								<a
									href="#nav-profile" class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" role="tab"
									aria-controls="nav-profile" aria-selected="false" @click="showProfile">
									<div class="row">
										<div class="col-2">
											<i class="fa fa-user"></i>
										</div>
										<div class="col-9">
											<p class="mb-0"><b>PROFILE</b></p>
										</div>
									</div>
								</a>
								<!--								<a-->
								<!--									class="nav-item nav-link" id="nav-connection-tab" data-toggle="tab" href="#nav-contact" role="tab"-->
								<!--									aria-controls="nav-contact" aria-selected="false">-->
								<!--									<div class="row">-->
								<!--										<div class="col-2">-->
								<!--											<i class="fa fa-user"></i>-->
								<!--										</div>-->
								<!--										<div class="col-10">-->
								<!--											<p class="mb-0"><b>CONNECTION</b></p>-->
								<!--										</div>-->
								<!--									</div>-->
								<!--								</a>-->
							</div>
						</nav>
						<div class="card-body" style="background: #000; border-radius: 0 0 12px 12px">
							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
									<home class="container-fluid" v-show="home"></home>
								</div>
								<div class="tab-pane fade" id="nav-event" role="tabpanel" aria-labelledby="nav-event-tab">
									<events class="container-fluid" v-show="event"></events>
								</div>
								<profile class="container-fluid" v-show="profile"></profile>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
  import navComponent from '@/components/dashboard/nav.vue'
  import sideBar from '@/components/dashboard/side-bar.vue'
  import home from '@/components/dashboard/home.vue'
  import events from '@/components/dashboard/events.vue'
  import profile from '@/components/dashboard/profile.vue'
  export default {
    name: 'dashboard',
    data() {
      return {
        user: {is_admin: false},
        upcomingEvents: [],
        teams: [],
        events: [],
        registered_user_count: 0,
        home: true,
        event: false,
        profile: false,
      }
    },
    components: {
      navComponent,
      sideBar,
      home,
      events,
      profile
    },
    created() {
      this.user = JSON.parse(localStorage.getItem('user_info'))
      if (this.user === null) {
        this.$router.push('/')
      }
      this.teamMembers()
      this.eventList()
    },
    methods: {
      showHome() {
        this.home = true
        this.event = false
        this.profile = false
      },
      showEvent() {
        this.home = false
        this.event = true
        this.profile = false
      },
      showProfile() {
        this.home = false
        this.event = false
        this.profile = true
      }
    }
  }
</script>

<style scoped>
	.data-scroll {
		display: flex;
		overflow-x: auto
	}
	.nav-link div{
		margin: 5px 0px;
	}
	h6 {
		margin: 10px 0px;
		font-size: 10px;
		font-weight: bold;
		width: 100%;
		text-align: center;
		border-bottom: 1px solid rgb(87, 81, 81);
		line-height: 0;
	}

	h6 span {
		padding: 0 30px;
	}
	.active-list{
		background: #344c67;
		border-radius: 10px;
		padding: 10px;
	}
	ul {
		margin: 0;
		padding: 0px;
	}
	ul li {
		padding: 10px;
		margin: 10px;
	}
</style>
